import { render, staticRenderFns } from "./NewLayout.vue?vue&type=template&id=0c25d8aa&"
import script from "./NewLayout.vue?vue&type=script&lang=js&"
export * from "./NewLayout.vue?vue&type=script&lang=js&"
import style0 from "./NewLayout.vue?vue&type=style&index=0&id=0c25d8aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports